import React from 'react';

import { TranslatePlural, useI18n } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

type Props = {
	firstDmName?: string;
	count: number;
};

export const DecisionMakersText: React.FC<Props> = ({ firstDmName = '', count }) => {
	const { localizeNumber } = useI18n();
	const restCount = count - 1;

	return (
		<ClientRender
			placeholder={
				<TranslatePlural
					value="corgi.petition_gamma.content_summary.decision_makers"
					count={count}
					replacements={{ firstDm: firstDmName, dmsCount: restCount.toString() }}
				/>
			}
		>
			{() => (
				<TranslatePlural
					value="corgi.petition_gamma.content_summary.decision_makers"
					count={count}
					replacements={{ firstDm: firstDmName, dmsCount: localizeNumber(restCount) }}
				/>
			)}
		</ClientRender>
	);
};
